/* ───────── helpers ───────── */
const toMoney = (n) =>
  Number.isFinite(n)
    ? n.toLocaleString("en-GB", { style: "currency", currency: "GBP" })
    : "£0.00";
const toPct = (n) => (Number.isFinite(n) ? `${n.toFixed(2)}%` : "0%");
const safeFixed = (n, d = 2) =>
  Number.isFinite(n) ? Number(n.toFixed(d)) : 0;
const dashIfNaN = (v) => (Number.isFinite(v) ? toMoney(safeFixed(v)) : "£0.00");

const coerceNum = (v) =>
  v === "" || v === null || Number.isNaN(Number(v))
    ? ""
    : Math.max(0, Number(v));

const monthlyFromTerm = (balance = 0, apr = 0, years = 0) => {
  const n = Math.max(0, Math.round(Number(years) * 12));
  const r = Number(apr) > 0 ? Number(apr) / 100 / 12 : 0;
  if (n <= 0) return 0;
  if (r === 0) return balance / n;
  return (balance * r) / (1 - Math.pow(1 + r, -n));
};

const ccMinPayment = (balance = 0) => balance * 0.01;

// months to clear a balance given APR and fixed monthly payment
const monthsToClear = (balance = 0, apr = 0, payment = 0) => {
  const B = Number(balance) || 0;
  const r = Number(apr) > 0 ? Number(apr) / 100 / 12 : 0;
  const P = Number(payment) || 0;

  if (B <= 0 || P <= 0) return NaN;
  if (r === 0) return B / P;
  if (P <= r * B) return Infinity;

  const n = -Math.log(1 - (r * B) / P) / Math.log(1 + r);
  return n; // months
};

const formatYearsMonths = (months = 0) => {
  const m = Math.max(0, Math.round(months));
  const y = Math.floor(m / 12);
  const rem = m % 12;
  if (y > 0 && rem > 0)
    return `${y} year${y > 1 ? "s" : ""} ${rem} month${rem > 1 ? "s" : ""}`;
  if (y > 0) return `${y} year${y > 1 ? "s" : ""}`;
  return `${rem} month${rem === 1 ? "" : "s"}`;
};

export {
  toMoney,
  toPct,
  safeFixed,
  dashIfNaN,
  coerceNum,
  monthlyFromTerm,
  ccMinPayment,
  monthsToClear,
  formatYearsMonths,
};
